import { Slide } from "@jelly/lesson";

import { task as task05 } from "../../../../../task/course-02/lesson-12/task-05";

const task: Slide = {
  titleHtml: "Which of the following helps in localization<br>of sound sources in the median plane (phi=0)",
  description: "Select all true statements.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task05.id,
        },
      },
    },
  },
};

export default task;
